<template>
  <div class="p-5">
    <div class="d-flex align-items-center justify-content-between mb-6 pb-3">
      <h3>
        Detalhes
      </h3>
      <button
        class="btn btn-circle btn-20 bg-neutral-076"
        @click.prevent="$emit('close')"
      >
        <i class="fa-regular fa-xmark fs-14" />
      </button>
    </div>
    <!-- <b-tabs v-if="participant" justified>
        <b-tab title="Dados do cliente" active class="pt-4"> -->
    <div class="row" v-if="participant">
      <div class="col-lg-6 mb-6">
        <bp-input
          label="Nome"
          v-model="participant.shopper_name"
          placeholder="Nome"
          disabled
        />
      </div>
      <div class="col-lg-6 mb-6">
        <bp-input
          label="Nome"
          v-model="participant.shopper_email"
          placeholder="Buscar"
          disabled
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          label="Telefone"
          v-model="participant.shopper_phone"
          placeholder="Nome"
          disabled
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          label="Documento de identificação"
          v-model="participant.shopper_document"
          placeholder="Buscar"
          disabled
        />
      </div>
    </div>

    <div
      class="mt-6 d-flex flex-column flex-lg-row justify-content-end"
      v-if="!participant.checkin_at"
    >
      <button
        class="btn btn-new-outline-primary btn-40"
        :disabled="loading"
        @click="resend"
      >
        <loading :show="loading">
          Reenviar ingresso
        </loading>
      </button>
      <button
        class="btn btn-new-outline-primary btn-40 mt-3 mt-lg-0 ml-lg-3 "
        :disabled="loading"
        @click="edit_participant_visible = true"
      >
        <loading :show="loading">
          Editar dados
        </loading>
      </button>
    </div>
    <!-- </b-tab>
        <b-tab title="Histórico" class="pt-6">
          <participant-history :participant="participant" />
        </b-tab>
      </b-tabs> -->
    <responsive-modal v-model="edit_participant_visible" size="lg">
      <event-edit-participant-details-modal
        :participant="participant"
        @close="edit_participant_visible = false"
        @updatedParticipant="value => updatedParticipant(value)"
      />
    </responsive-modal>
  </div>
</template>
<script>
import EventEditParticipantDetailsModal from "../../events/EventEditParticipantDetailsModal.vue";

export default {
  components: { EventEditParticipantDetailsModal },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      participant: { ...this.data },
      edit_participant_visible: false
    };
  },
  methods: {
    resend() {
      this.loading = true;
      this.$store
        .dispatch("events/resendEmail", this.participant?.code)
        .then(() => this.$message.success("Ingresso reenviado por e-mail"))
        .catch(e => {
          const message =
            e.response.participant?.detail || "Erro ao reenviar ingresso";
          this.$message.error(message);
        })
        .finally(() => (this.loading = false));
    },
    updatedParticipant(item) {
      this.participant = item;
    }
  }
};
</script>
